/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Utils" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssFeatureService } from "VSS/Platform/Feature";
import { IVssLocationService } from "VSS/Platform/Location";

export function getImageLocation(pageContext: IVssPageContext, imageRelativePath: string): string {
    const locationService = pageContext.getService<IVssLocationService>("IVssLocationService");
    return locationService.getAssetLocation(imageRelativePath);
}

export function getFeatureFlagState(pageContext: IVssPageContext, featureFlag: string): boolean {
    const featureService: IVssFeatureService = pageContext.getService<IVssFeatureService>("IVssFeatureService");
    try {
        return featureService.isFeatureFlagEnabled(featureFlag);
    } catch (err) {
        return false;
    }
}
